































































import Vue from "vue";
import logger from '@plat-components/utils2/_esm5/logger'
import { parseParamToObj } from '@plat-components/utils2/_esm5/url'

import Section0 from "./Section0.vue";
import Section1 from "./Section1.vue";
import Section2 from "./Section2.vue";
import Section3 from "./Section3.vue";
import Section4 from "./Section4.vue";
import Section5 from "./Section5.vue";
import Share from "./Share.vue";
import SideMenu from "./Menu.vue";

import { mp4Link } from '@/constant'

import {
  sceneStream,
  slideStream,
  sceneChangeStream,
  pageZoomStream,
  historyPopStateStream
} from "@/streams";
import { mutateState } from "@/store";
import { menu } from "@/constant";

const LoadImgMap: {[p: string]: boolean} = {}
const isTablet = (window as any).isTablet

export default Vue.extend({
  components: {
    Section0,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Share,
    SideMenu
  },
  data() {
    return {
      height: window.innerHeight,
      scene: 0,
      // tabranklist 单页内，含有tab的index值，用于切换背景图片
      slide: 0,
      isTablet,
      mp4Link,
      list: menu.filter(now => now.idx !== -1)
    };
  },
  computed: {
    bgImg() {
      // @ts-ignore
      const { scene, list, slide } = this;
      if (list[scene].type === 'tabranklist') {
        return list[scene].groups[slide].bg
      } else {
        return list[scene].bg;
      }
    }
  },

  methods: {
    initVideoBG() {
      // console.log('Bideo init')
      if (this.isTablet) return
      // @ts-expect-error
      const bv = new window.Bideo()
      const src = mp4Link
      // const self = this
      const videoLoop = this.$refs.videoLoop

      bv.init({
        videoEl: videoLoop,
        container: this.$refs.videoWrapper,
        resize: true,
        autoplay: true,
        isMobile: false,
        src: [{
          src,
          type: 'video/mp4',
        }],
        onPlay: () => {
          // this.canPlay = true
          // self.$emit('load')
          // const bvLoop = new Bideo()
          // bvLoop.init({
          //   videoEl: videoLoop,
          //   container: self.$refs.kvWrapper,
          //   resize: true,
          //   autoplay: true,
          //   isMobile: false,
          //   delay: 3000,
          //   src: [{
          //     src: KVBg,
          //     type: 'video/mp4'
          //   }],
          //   onPlay() {
          //     // self.videoLoopShow = true
          //   }
          // })
        },
      })
    },
    loadNextImg() {
      // @ts-ignore
      const { scene, list } = this;
      let img = ''
      const item = list[scene + 1]
      if (!item) return
      if (item.type === 'tabranklist') {
        // @ts-ignore
        img = (item.groups[0] && item.groups[0].bg) || ''
      } else {
        img = item.bg;
      }
      if(!img || LoadImgMap[img]) return
      const ImgInstence = new Image()
      ImgInstence.src = img
      LoadImgMap[img] = true
    }
  },

  mounted() {
    mutateState(state => {
      const str = location.hash.replace("#", "");
      const [scenestr = "", slidestr = ""] = str.split("-");
      state.scene = +scenestr.replace("scene", "") || 0;
      state.slide = +slidestr.replace("slide", "") || 0;
    });

    historyPopStateStream.subscribe();

    sceneChangeStream.subscribe(v => {
      const lastScene = this.scene
      // console.log('sceneChangeStream', lastScene, v)
      if (lastScene > v) {
        logger('pageup')
      } else if (lastScene < v) {
        logger('pagedown')
      }
      mutateState(state => {
        state.scene = v;
        state.slide = 0;

        this.loadNextImg()
      });
    });

    pageZoomStream.subscribe(() => {
      this.height = window.innerHeight;
    });

    sceneStream.subscribe(v => {
      this.scene = +v;
      this.loadNextImg()
      if (this.scene === 0) {
        setTimeout(() => {
          this.scene === 0 && this.initVideoBG()
        }, 650)
      }
    });
    slideStream.subscribe(v => {
      this.slide = +v;
    });

    const param = parseParamToObj(location)
    const from = param['share_source'] || param['from_module'] || 'default'
    logger('pageshow', { from })
  },
});
